/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_N4Inputs */

const en_minifier_ref_n4 = /** @type {(inputs: Minifier_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minified and gzipped. Only 10.3 percent below the gzipped baseline.`)
};

const ko_minifier_ref_n4 = /** @type {(inputs: Minifier_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축 후 gzip입니다. gzip 기준값보다 10.3퍼센트밖에 작지 않습니다.`)
};

const ja_minifier_ref_n4 = /** @type {(inputs: Minifier_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮後に gzip をかけたものです。gzip 基準値より 10.3 パーセントしか小さくありません。`)
};

/**
* | output |
* | --- |
* | "Minified and gzipped. Only 10.3 percent below the gzipped baseline." |
*
* @param {Minifier_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_n4 = /** @type {((inputs?: Minifier_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_n4(inputs)
	if (locale === "ko") return ko_minifier_ref_n4(inputs)
	return ja_minifier_ref_n4(inputs)
});